module.exports = __webpack_public_path__ + "img/filter-icon.0b7431f9.svg";